import { FormValidationStatus } from '@customTypes/FormValidationStatus'
import clsx from 'clsx'
import React, { useImperativeHandle, useRef, useState } from 'react'
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'
import s from './TextInput.module.scss'

interface Props {
  validationStatus?: FormValidationStatus
}
type NativeAttrs = Omit<React.ComponentPropsWithoutRef<'input'>, keyof Props>

export type TextInputProps = Props & NativeAttrs

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (
    { className, validationStatus, value, required, ...props },
    forwardedRef,
  ) => {
    // Handle ref forwarding
    const ref = useRef<HTMLInputElement>(null)
    useImperativeHandle(forwardedRef, () => ref.current)

    // // while mouse down on passwordToggle,change the type of input to text
    // const handleMouseDown = (e: React.MouseEvent<HTMLInputElement>) => {
    //   e.preventDefault()

    //   if (ref.current) {
    //     ref.current.type = 'text'
    //     setShowPassword(true)
    //   }
    // }

    // // while mouse up on passwordToggle,change the type of input to password
    // const handleMouseUp = (e: React.MouseEvent<HTMLInputElement>) => {
    //   e.preventDefault()
    //   if (ref.current) {
    //     ref.current.type = 'password'
    //     setShowPassword(false)
    //   }
    // }

    const [showPassword, setShowPassword] = useState(false)

    const handleShowPassword = () => {
      if (ref.current) {
        ref.current.type = showPassword ? 'password' : 'text'
        setShowPassword(!showPassword)
      }
    }

    return (
      <span className={clsx(className, s.textInputWrapper)}>
        <input
          aria-invalid={validationStatus === 'error' ? 'true' : undefined}
          aria-required={required}
          ref={ref}
          value={value}
          placeholder=" "
          {...props}
        />

        {props.type === 'password' && (
          <div className={s.passwordToggle} onClick={handleShowPassword}>
            {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
          </div>
        )}
      </span>
    )
  },
)

TextInput.displayName = 'TextInput'
export default TextInput
